export class TrackingUpdateEventArgument {

  context: string;
  calculationIds: string[];

  constructor(contextId: string) {
    this.calculationIds = [];
    this.context = contextId;
  }

  addCalculationId(id: string) {
    this.calculationIds.push(id);
  }
}
